import { select, axisLeft } from "d3";
import { useRef, useEffect } from "react";
import { AxisLeftProps } from "../props";

const AxisLeft = ({ scale }: AxisLeftProps) => {
    const ref = useRef<SVGGElement>(null);

    useEffect(() => {
        if (ref.current) {
            select(ref.current).call(axisLeft(scale));
        }
    }, [scale]);

    return <g ref={ref} />;
}

export default AxisLeft;